import React from "react";
import { Grid, TextField } from "@material-ui/core";
import { validateSheetFormat } from "./sheetFormatLogic";

const CAMPOS = [
  { key: "columnas", label: "Columnas por hoja", unidad: "" },
  { key: "filas", label: "Filas por hoja", unidad: "" },
  { key: "etiquetaAncho", label: "Ancho de cada etiqueta", unidad: "mm" },
  { key: "etiquetaAlto", label: "Alto de cada etiqueta", unidad: "mm" },
  { key: "margenSuperior", label: "Margen superior de la hoja", unidad: "mm" },
  { key: "margenInferior", label: "Margen inferior de la hoja", unidad: "mm" },
  { key: "margenIzquierdo", label: "Margen izquierdo de la hoja", unidad: "mm" },
  { key: "margenDerecho", label: "Margen derecho de la hoja", unidad: "mm" },
  { key: "separacionHorizontal", label: "Separación entre etiquetas (derecha)", unidad: "mm" },
  { key: "separacionVertical", label: "Separación entre etiquetas (abajo)", unidad: "mm" },
];

export default function SheetFormatEditor({ value, onChange }) {
  const errores = validateSheetFormat(value);

  function cambiarCampo(key, nuevoValorTexto) {
    const n = nuevoValorTexto === "" ? "" : Number(nuevoValorTexto);
    onChange({ ...value, [key]: n });
  }

  return (
    <Grid container spacing={2}>
      {CAMPOS.map((campo) => (
        <Grid item xs={6} sm={3} key={campo.key}>
          <TextField
            label={campo.label}
            type="number"
            fullWidth
            value={value[campo.key]}
            onChange={(e) => cambiarCampo(campo.key, e.target.value)}
            error={!!errores[campo.key]}
            helperText={errores[campo.key] || campo.unidad || " "}
            inputProps={{ step: campo.unidad === "mm" ? 0.5 : 1 }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
